import React, { useEffect, useState } from 'react';
import { Box } from '@indeed/ifl-components';
import { SuccessAlert } from 'Components/Notifications/Notifications';
import Logo from 'Img/indeed-logo.svg';
import JsvMetricsLogger from 'Utils/JsvMetricsLogger';
import { LegalDisclaimer } from 'Views/HomePage/LegalDisclaimer';
import PassportLinks from 'Views/StartPage/_PassportLinks';
import { style } from './ForceLoginPage.jss';
export default function ForceLoginPage() {
    const [alertShown, setAlertShown] = useState(true);
    useEffect(() => {
        JsvMetricsLogger.log('page_view', 'show_forcelogin_screen', 'forcelogin_screen');
    }, []);
    return (React.createElement(Box, { className: "ForceLoginPage", sx: style.main },
        React.createElement(Box, { sx: style.content },
            React.createElement("div", null,
                React.createElement("img", { src: Logo, alt: "" }),
                React.createElement(Box, { as: "span", sx: style.logoLabel }, "\u5C65\u6B74\u66F8\u4F5C\u6210")),
            React.createElement(Box, { sx: style.message },
                React.createElement(Box, { sx: style.title }, "\u3088\u3046\u3053\u305D\uFF01"),
                React.createElement(Box, { sx: style.description },
                    "\u304A\u5BA2\u69D8\u306E\u30C7\u30FC\u30BF\u306F\u5F53\u793E\u3067\u5B89\u5168\u306B\u7BA1\u7406\u3055\u308C\u307E\u3059\u3002",
                    React.createElement("br", null),
                    "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30ED\u30B0\u30A4\u30F3\u3082\u3057\u304F\u306F\u65B0\u898F\u767B\u9332\u3092\u3057\u3066\u4F5C\u6210\u3092\u59CB\u3081\u307E\u3057\u3087\u3046\u3002"),
                React.createElement(PassportLinks, { nextPath: "/home" }))),
        React.createElement(Box, { sx: style.legalLinks },
            React.createElement(Box, { sx: style.legalLinksDivider }),
            React.createElement(Box, { sx: style.legalDisclaimer },
                React.createElement(LegalDisclaimer, null))),
        alertShown && (React.createElement(SuccessAlert, { alertType: "logout", onDismiss: () => setAlertShown(false) }))));
}
